// extracted by mini-css-extract-plugin
export default {"pwa_button":"InstallPwaButtonStyles_pwa_button__M8jNH"};